module.exports = __webpack_public_path__ + "static/media/6.ed9d94cf.png";